export default "__VITE_ASSET__DMh0v$z8__"